import { render, staticRenderFns } from "./SyncFacebookPageAccountDetails.vue?vue&type=template&id=0365063a&scoped=true&"
import script from "./SyncFacebookPageAccountDetails.vue?vue&type=script&lang=ts&"
export * from "./SyncFacebookPageAccountDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SyncFacebookPageAccountDetails.vue?vue&type=style&index=0&id=0365063a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365063a",
  null
  
)

export default component.exports